export default function (addUser, $state, toaster, userRoles) {
    const vm = this;

    vm.allRoles = userRoles.items;
    vm.roles = {};
    vm.rolesError = null;

    for (let count = 0; count < vm.allRoles.length; count++) {
        vm.roles[vm.allRoles[count].value] = false;
    }

    vm.model = {};
    vm.form = null;
    vm.addUser = add;
    vm.rolesChange = rolesChange;
    vm.selected = [];
    vm.disable = disable;

    function rolesChange(role) {
        const pos = vm.selected.indexOf(role);
        if (pos > -1) {
            vm.selected.splice(pos, 1);
        } else {
            vm.selected.push(role);
        }
    }

    function disable(role) {
        return vm.selected.length >= 1 && vm.selected.indexOf(role) === -1;
    }

    function add() {
        if (vm.form.$invalid) {
            return;
        }

        vm.model.roles = [];
        vm.rolesError = null;

        for (let countAllRoles = 0; countAllRoles < vm.allRoles.length; countAllRoles++) {
            if (vm.roles[vm.allRoles[countAllRoles].value]) {
                vm.model.roles.push(vm.allRoles[countAllRoles].roleToSave);
            }
        }

        if (!vm.model.roles.length) {
            vm.rolesError = {required: true};
            return;
        }

        addUser(vm.model)
            .then(() => {
                $state.go('users.list');
                toaster.pop('success', 'The user has been successfully created');
            })
            .catch(e => {
                toaster.pop('error', e.data);
            });
    }
}



// WEBPACK FOOTER //
// ./Client/app/admin/users/controllers/add/addUserCtrl.js